import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { IKimRecipientFilter } from 'src/app/shared/models/kim/kim.model';

@Component({
  selector: 'itl-kim-recipient-filter',
  templateUrl: './kim-recipient-filter.component.html',
  styleUrls: ['./kim-recipient-filter.component.scss'],
})
export class KimRecipientFilterComponent implements OnInit {
  @Input() filter: IKimRecipientFilter = {};

  public form: UntypedFormGroup;

  constructor(
    private _modalController: ModalController,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.form = this._formBuilder.group({
      street: [null],
      postalCode: [null],
      locality: [null],
    });
  }

  ngOnInit(): void {
    this.form.patchValue({
      street: this.filter?.street ?? null,
      postalCode: this.filter?.postalCode ?? null,
      locality: this.filter?.locality ?? null,
    });
  }

  public async cancel(): Promise<void> {
    await this._modalController.dismiss();
  }

  public async done(): Promise<void> {
    const filter: IKimRecipientFilter = {
      street: this.form.value.street || undefined,
      postalCode: this.form.value.postalCode || undefined,
      locality: this.form.value.locality || undefined,
    };
    await this._modalController.dismiss(filter);
  }

  public resetFilter(): void {
    this.form.reset();
    this.form.markAsDirty();
  }
}
